module.exports = __webpack_public_path__ + "static/media/camera_default.1319b3e0.svg";